// extracted by mini-css-extract-plugin
export var paymentContainer = "donate-module--paymentContainer--3ZtyQ";
export var bgContainer = "donate-module--bgContainer--3yuJn";
export var bg = "donate-module--bg--AExj6";
export var bgImage = "donate-module--bgImage--2-uLA";
export var opacityLayer = "donate-module--opacityLayer--Ej9n2";
export var texts = "donate-module--texts--13vKT";
export var quote = "donate-module--quote--2v1QH";
export var stepContainer = "donate-module--stepContainer--HNhKi";
export var paymentFormContainer = "donate-module--paymentFormContainer--1MCK8";